import { TPill } from '../components/MessageBox';

export const c2bFinancingKey = 'c2b_financing';
export const c2bTestDriveKey = 'c2b_test_drive';
export const c2bCallbackKey = 'c2b_call';
export const c2cCallbackKey = 'c2c_call';
export const c2cViewingKey = 'c2c_viewing';

export const b2cPills: TPill[] = [
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.call.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.call.body',
    icon: 'call_back',
    gaLabel: c2bCallbackKey,
  },
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.askviewing.c2b.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.schedule.bodyv2',
    icon: 'calendar',
    gaLabel: c2bTestDriveKey,
  },
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.finance.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.finance.body',
    icon: 'euros',
    gaLabel: c2bFinancingKey,
  },
];

export const b2cCaravansAndCampingPills: TPill[] = [
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.call.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.call.body',
    icon: 'call_back',
    gaLabel: c2bCallbackKey,
  },
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.viewing.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.viewing.body',
    icon: 'calendar',
    gaLabel: c2bTestDriveKey,
  },
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.finance.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.finance.body',
    icon: 'euros',
    gaLabel: c2bFinancingKey,
  },
];

export const c2cPills: TPill[] = [
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.askcall.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.askcall.body',
    icon: 'call_back',
    gaLabel: c2cCallbackKey,
  },
  {
    labelKey: 'sellerContact.asq.modal.car.message.canned.askviewing.c2c.pill',
    contentKey: 'sellerContact.asq.modal.car.message.canned.askviewing.c2c.body',
    icon: 'calendar',
    gaLabel: c2cViewingKey,
  },
];

export const MAX_UPLOAD_PHOTOS = 8;
